/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowNarrowLeft = createReactComponent(
  "arrow-narrow-left",
  "IconArrowNarrowLeft",
  [
    ["path", { d: "M5 12l14 0", key: "svg-0" }],
    ["path", { d: "M5 12l4 4", key: "svg-1" }],
    ["path", { d: "M5 12l4 -4", key: "svg-2" }]
  ]
);

export { IconArrowNarrowLeft as default };
//# sourceMappingURL=IconArrowNarrowLeft.js.map
